import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const BusinessDescription = ({ business }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 300;
  const shouldTruncate = business?.fullDescription?.length > maxLength;

  const displayText = shouldTruncate && !isExpanded 
    ? business?.fullDescription?.substring(0, maxLength) + '...'
    : business?.fullDescription;

  return (
    <div className="bg-card rounded-lg p-6">
      <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
        About {business?.name}
      </h2>
      <div className="prose prose-sm max-w-none">
        <p className="text-foreground font-body leading-relaxed whitespace-pre-line">
          {displayText}
        </p>
        
        {shouldTruncate && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="mt-3 flex items-center space-x-1 text-primary hover:text-primary/80 font-body font-medium transition-gentle"
          >
            <span>{isExpanded ? 'Show less' : 'Read more'}</span>
            <Icon 
              name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
              size={16} 
            />
          </button>
        )}
      </div>
      {/* Key Features */}
      {business?.keyFeatures && business?.keyFeatures?.length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-heading font-medium text-foreground mb-3">
            Key Features
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {business?.keyFeatures?.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2">
                <Icon name="Check" size={16} className="text-success flex-shrink-0" />
                <span className="text-foreground font-body">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* Certifications */}
      {business?.certifications && business?.certifications?.length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-heading font-medium text-foreground mb-3">
            Certifications & Qualifications
          </h3>
          <div className="flex flex-wrap gap-2">
            {business?.certifications?.map((cert, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-success/10 text-success text-sm font-body rounded-full border border-success/20"
              >
                {cert}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessDescription;